/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Text } from './Text';
import { Title } from './Title';

const RebalanceOrSellExpired = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'error'} />
      <Title>{t('NOTIFICATION_REBALANCE_OR_SELL_EXPIRED_MODAL__title')}</Title>
      <Text>{t('NOTIFICATION_REBALANCE_OR_SELL_EXPIRED_MODAL__desc')}</Text>
    </>
  );
};

export { RebalanceOrSellExpired };
